



























































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game } from '@/class/game'
import { GamePlayer } from '@/class/gamePlayer'
import { RoleId, CauseOfDeath } from '@/enum'
import CardArea from '@/components/Game/Common/CardArea.vue'
import PlayerListItemAction from './PlayerListItemAction.vue'
import { PlayerListItemActionComponentInterface } from './PlayerListItemAction.vue'
import StatusIcons from './StatusIcons.vue'
import { StatusIconsComponentInterface } from './StatusIcons.vue'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'
import SimpleModal from '@/components/Utils/modal/SimpleModal.vue'

export interface PlayerListItemComponentInterface {
  game: Game
  playerSelf?: GamePlayer
  inSelectTime: boolean
  inVoteTime: boolean
  isGallary: boolean
  isFullopen: boolean
  onClickPlayer(player: GamePlayer): void
  playerId: string
  votedCount: number
  isVotedFirstPlace: boolean
  isVotedSecondPlace: boolean
}

@Component({
  components: {
    StatusIcons,
    CardArea,
    PlayerListItemAction,
    BtnSquare,
    SimpleModal,
  }
})
export default class PlayerListItem extends Vue {
  @Prop() data!: PlayerListItemComponentInterface;

  showsActionModal = false

  get game() {
    return this.data.game
  }

  get isSelf() {
    return this.playerSelf?.id === this.data.playerId
  }

  get playerSelf() {
    return this.data.playerSelf
  }

  get canUseArmor (): boolean {
    return this.playerSelf?.roleId === RoleId.survivor && this.playerSelf?.restArmor > 0
  }

  get canDetonate (): boolean {
    return this.playerSelf?.roleId === RoleId.bomber
        && this.game.players.filter(player => !player.isDead && player.bomb).length > 0
  }

  get player() {
    return this.game.gamePlayerOf[this.data.playerId]
  }

  get showsVotedCount() {
    return this.game.settings.dayVote && this.game.isDay
  }

  get showsVotedPlayer() {
    if (this.data.isFullopen) {
      return true
    }

    if (this.isSelf) {
      return true
    }

    return this.game.settings.dayVote && this.game.isDay
  }

  get showsSelectedPlayer (): boolean {
    if (this.data.isFullopen) {
      return true
    }

    if (this.isSelf) {
      return true
    }

    if (this.playerSelf?.roleId === RoleId.mafia || this.playerSelf?.roleId === RoleId.godfather) {
      if (this.player.roleId === RoleId.mafia || this.player.roleId === RoleId.godfather) {
        return true
      }
    }

    return false
  }

  get isTalkTurn(): boolean {
    return this.game.finalVoteTalkerId === this.data.playerId
  }

  get isFinalVoteTarget(): boolean {
    return this.game.roomFinalVotePlayerIds.some(id => id === this.data.playerId)
  }

  get isPunished () {
    return this.player.deathDetails?.cause === CauseOfDeath.punished
  }

  get isKilled () {
    return this.player.deathDetails && this.player.deathDetails.cause !== CauseOfDeath.punished
  }

  get showsBomb(): boolean {
    if (this.data.isFullopen) {
      return true
    }

    return this.playerSelf?.roleId === RoleId.bomber
  }

  get showsCrab(): boolean {
    if (this.data.isFullopen) {
      return true
    }

    if (this.data.playerId === this.data.playerSelf?.id) {
      return true
    }

    return false
  }

  get showsGuard(): boolean {
    if (this.data.isFullopen) {
      return true
    }

    if (
      this.playerSelf?.roleId === RoleId.doctor &&
      this.playerSelf.lastNightSelectedPlayerId === this.data.playerId
    ) {
      return true
    }

    return false
  }

  get showsTempt(): boolean {
    if (this.data.isFullopen) {
      return true
    }

    if (this.data.playerId === this.playerSelf?.id) {
      return true
    }

    if (
      (this.playerSelf?.roleId === RoleId.prostitute || this.playerSelf?.roleId === RoleId.dancer) &&
      this.playerSelf.lastNightSelectedPlayerId === this.data.playerId
    ) {
      return true
    }

    return false
  }

  get showsScammed(): boolean {
    if (this.data.isFullopen) {
      return true
    }

    if (
      this.playerSelf?.roleId === RoleId.trickster &&
      this.playerSelf.lastNightSelectedPlayerId === this.data.playerId
    ) {
      return true
    }

    return false
  }

  get showsStolen(): boolean {
    if (this.data.isFullopen) {
      return true
    }

    if (this.data.playerId === this.playerSelf?.id && this.player.role.weapon) {
      return true
    }

    if (
      this.playerSelf?.roleId === RoleId.pickpocket &&
      this.playerSelf?.status.success &&
      this.playerSelf.lastNightSelectedPlayerId === this.data.playerId
    ) {
      return true
    }

    return false
  }

  get showsBulletCount(): boolean {
    if (this.player.roleId !== RoleId.sniper) {
      return false
    }

    if (this.data.isFullopen) {
      return true
    }

    if (this.isSelf) {
      return true
    }

    return false
  }

  get showsArmorCount(): boolean {
    if (this.player.roleId !== RoleId.survivor) {
      return false
    }

    if (this.data.isFullopen) {
      return true
    }

    if (this.isSelf) {
      return true
    }

    return false
  }

  get showsStealCount(): boolean {
    if (this.player.roleId !== RoleId.pickpocket) {
      return false
    }

    if (this.data.isFullopen) {
      return true
    }

    if (this.isSelf) {
      return true
    }

    return false
  }

  get showsShieldCount(): boolean {
    if (this.player.roleId !== RoleId.bomber) {
      return false
    }

    if (this.data.isFullopen) {
      return true
    }

    return false
  }

  get showsRole(): boolean {
    if (this.data.isFullopen) {
      return true
    }

    if (this.player.isOpened) {
      return true
    }

    if (this.isKnownRole) {
      return true
    }

    return false
  }

  get isKnownRole(): boolean {
    if (this.data.playerId === this.playerSelf?.id) {
      return true
    }

    if (this.playerSelf?.role.openRoles.some(roleId => roleId === this.player.roleId)) {
      return true
    }

    return false
  }

  get isSelected() {
    return this.playerSelf?.selectedPlayerId === this.data.playerId
  }

  get isVoted() {
    return this.playerSelf?.votedPlayerId === this.data.playerId
  }

  get votedCount() {
    return this.data.votedCount
  }

  get playerListItemActionData(): PlayerListItemActionComponentInterface {
    return {
      ...this.data,
      showsRole: this.showsRole,
      statusIconsData: this.statusIconsData,
      isSelected: this.isSelected,
      isVoted: this.isVoted,
    }
  }

  get statusIconsData(): StatusIconsComponentInterface {
    return {
      player: this.player,
      showsBomb: this.showsBomb,
      showsCrab: this.showsCrab,
      showsGuard: this.showsGuard,
      showsTempt: this.showsTempt,
      showsScammed: this.showsScammed,
      showsStolen: this.showsStolen,
    }
  }

  getPlayerName (playerId: string): string {
    return playerId ? this.game.gamePlayerOf[playerId].name : ""
  }

  toggleUseArmor() {
    if (this.data.isGallary || this.playerSelf?.turnEnd) return

    this.playerSelf?.toggleUseArmor()
  }

  toggleDetonate() {
    if (this.data.isGallary || this.playerSelf?.turnEnd) return

    this.playerSelf?.toggleDetonate()
  }

  showActionModal() {
    this.showsActionModal = true
  }
}
